import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/legacy-rwa/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Total debt"
          variant="dai"
          data={data}
          field="debt"
          options={{
            trend: true,
            valueOptions: {
              currencyValueOptions: {
                currency: tokensMapping('DAI'),
                iconSize: '3'
              }
            }
          }}
        />
      </Flex>
    );
  }

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
